export const scrolledToIndex = (target?: HTMLElement) => {
	if (target) {
		const scrollLeft = target.scrollLeft
		const width = target.offsetWidth
		return Math.round(scrollLeft / width)
	} else {
		return 0
	}
}
